import React from "react";
import { cilMenu } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CContainer, CHeader, CHeaderNav, CHeaderToggler } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import logo from "src/assets/images/logo.png";

import { AppHeaderDropdown } from "./header/index";

const AppHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: "set", sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <div className="d-flex justify-content-center align-items-center gap-2">
          {/* <img
            style={{ height: "56px", width: "auto" }}
            src={logo2}
            alt="Logo"
          /> */}
           <img
            style={{ height: "56px", width: "auto" }}
            src={logo}
            alt="Logo"
          />
          <div className="d-flex flex-column align-items-center">
            <span className="mt-2" style={{ fontWeight: "bold" }}>
              हरियाणा लोक सेवा आयोग
            </span>
            <span style={{ fontWeight: "bold" }}>
              Haryana Public Service Commission
              
            </span>
          </div>
         
        </div>
        <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default AppHeader;
